// Public FAQ API client (Phase 7 — FPUB-04).
//
// This module owns the unauthenticated public FAQ read against
// `GET /_api/faq`. Per Phase 5 D-13, the server-side `HtmlSanitizer`
// is THE trust boundary for the RTE answer field — this client is
// data-layer-only and performs zero client-side sanitization.
//
// Per Phase 7 CONTEXT D-04 this file MUST NOT import from
// `src/api/admin/*`; public and admin clients are intentionally
// decoupled (admin endpoints carry auth, the public endpoint does
// not). The response shape is locked by Phase 5 D-09 and is
// duplicated here intentionally — see `src/api/admin/types.ts` for
// the admin-side analog, but do NOT cross-import.
import { apiUrl } from '../game-mode';
/**
 * Fetch the full public FAQ tree from `GET /_api/faq`.
 *
 * Trilingual (de/en/cs) content for every category and item is returned
 * in a single response — callers render per-locale at render time, no
 * refetch on language switch. Categories and items are pre-sorted
 * ascending by `sorting` server-side (Phase 5 D-10); callers MUST NOT
 * re-sort defensively.
 *
 * NOTE: This uses a raw `fetch()` rather than the Hydra-unwrap GET
 * helpers in `src/api/game-mode` because those helpers extract
 * `data['hydra:member']` (API Platform pagination shape) and would
 * discard the `{ categories: [...] }` body returned by this endpoint
 * (CONTEXT D-03). No auth header is sent — the endpoint is public
 * and sits behind `ip_rate_limiter` server-side (Phase 5 D-21).
 *
 * On non-2xx responses this throws so the page can render the
 * `t('faq.error')` state (SPEC R-8 / CONTEXT D-12). The function does
 * NOT silently return `{ categories: [] }` — the page distinguishes
 * error from empty.
 */
export const getPublicFaqTree = async () => {
    const url = `${location.origin}${apiUrl}/faq`;
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Public FAQ fetch failed: ${response.status}`);
    }
    return (await response.json());
};
